/* @generated from adl module ferovinum.datacontracts.dealroll */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface DealRollRawRecord {
  id: common_strings.StringNE;
  fromDealLeg: common_strings.StringNE;
  toDealLeg: common_strings.StringNE;
  application: common_strings.StringNE;
  dealLegSaleId: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeDealRollRawRecord(
  input: {
    id: common_strings.StringNE,
    fromDealLeg: common_strings.StringNE,
    toDealLeg: common_strings.StringNE,
    application: common_strings.StringNE,
    dealLegSaleId: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): DealRollRawRecord {
  return {
    id: input.id,
    fromDealLeg: input.fromDealLeg,
    toDealLeg: input.toDealLeg,
    application: input.application,
    dealLegSaleId: input.dealLegSaleId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const DealRollRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.dealroll","decl":{"annotations":[{"value":{"datasetName":"raw_deal_roll"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"fromDealLeg","default":{"kind":"nothing"},"name":"fromDealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"toDealLeg","default":{"kind":"nothing"},"name":"toDealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"application","default":{"kind":"nothing"},"name":"application","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealLegSaleId","default":{"kind":"nothing"},"name":"dealLegSaleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"DealRollRawRecord","version":{"kind":"nothing"}}};

export const snDealRollRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.dealroll", name:"DealRollRawRecord"};

export function texprDealRollRawRecord(): ADL.ATypeExpr<DealRollRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snDealRollRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.dealroll.DealRollRawRecord" : DealRollRawRecord_AST
};
